module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/photo_6@2x-b7ca54fe24885e4c1179b70e5613bdea.jpg";